/* istanbul ignore file */
import * as Sentry from '@sentry/react';
import { useAuthentication } from '../authentication/authProvider';

export const WebApp = () => {
  const { accessToken } = useAuthentication();

  return (
    <div data-testid="web-app" className="bg-[#0090a6]">
      <div className="text-white p-8">
        <h1>
          <strong>This is page only for testing purpose and will be removed in future</strong>
        </h1>

        <h1>
          <strong>Access token</strong>
        </h1>
        <pre className="whitespace-pre-wrap break-words">
          {accessToken ?? 'No Access Token Available'}
        </pre>

        <br />
        <br />
        <button
          onClick={() => {
            try {
              throw new Error('This is your first error!');
            } catch (error) {
              Sentry.captureException(error);
            }
          }}
        >
          Send Error To Sentry
        </button>
      </div>
    </div>
  );
};
